import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from './api-authorization/AuthorizeService';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import AppRoutes from '../AppRoutes';
import Loader from './Loader';

const AuthRedirector: React.FC = () => {
    const navigate = useNavigate();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const redirectUser = async () => {
            let isAuthenticatedViaCookie = false;
            let userRoles: string[] = [];

            try {
                const authCheckResponse = await fetch('/api/Account/CurrentUser', {
                    credentials: 'include'
                });

                if (authCheckResponse.ok) {
                    const userData = await authCheckResponse.json();
                    isAuthenticatedViaCookie = true;
                    userRoles = Array.isArray(userData.roles) ? userData.roles : (userData.roles ? [userData.roles] : []);
                }
            } catch (error) {
                console.log('Cookie auth check failed, trying OIDC...', error);
            }

            if (isAuthenticatedViaCookie) {
                const firstAccessibleRoute = AppRoutes.find(route => {
                    if (!route.requireAuth || (route.path && route.path.startsWith(ApplicationPaths.ApiAuthorizationPrefix))) return false;
                    if (!route.roles || route.roles.length === 0) return true;
                    return route.roles.some(role => userRoles.includes(role));
                });

                navigate(firstAccessibleRoute ? firstAccessibleRoute.path : ApplicationPaths.LogOut, { replace: true });
                setIsReady(true);
                return;
            }

            const isAuthenticated = await authService.isAuthenticated();

            if (!isAuthenticated) {
                try {
                    const response = await fetch('/api/Account/HasAdmins');
                    const data = await response.json();
                    navigate(data.hasAdmins ? ApplicationPaths.Login : ApplicationPaths.Register, { replace: true });
                } catch (error) {
                    navigate(ApplicationPaths.Login, { replace: true });
                }
            } else {
                const user = await authService.getUser();
                const profile = user?.profile as { role?: string | string[] };
                const oidcUserRoles = Array.isArray(profile?.role) ? profile.role : (profile?.role ? [profile.role] : []);

                const firstAccessibleRoute = AppRoutes.find(route => {
                    if (!route.requireAuth || (route.path && route.path.startsWith(ApplicationPaths.ApiAuthorizationPrefix))) return false;
                    if (!route.roles || route.roles.length === 0) return true;
                    return route.roles.some(role => oidcUserRoles.includes(role));
                });

                navigate(firstAccessibleRoute ? firstAccessibleRoute.path : ApplicationPaths.LogOut, { replace: true });
            }
            setIsReady(true);
        };

        redirectUser();
    }, [navigate]);

    if (!isReady) {
        return <Loader />;
    }

    return null;
};

export default AuthRedirector;
